import { render } from "./Code.vue?vue&type=template&id=56c32876&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"

import "./Code.vue?vue&type=style&index=0&id=56c32876&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56c32876"

export default script